import { render } from "./icon-text.vue?vue&type=template&id=d6d5814c"
import script from "./icon-text.vue?vue&type=script&lang=js"
export * from "./icon-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__